import React, { forwardRef, useCallback, useState, useEffect, ReactNode } from 'react';
import clsx from 'clsx';
import { Input } from '@mui/base';
import './index.scss';

export interface RadioProps {
  disabled?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  name?: string;
  checked?: boolean;
  value?: string;
  children: ReactNode;
  className?: string;
  preventDefault?: boolean;
  parentClassName?: string;
}

const Radio = forwardRef<HTMLInputElement, RadioProps>(function Radio(props, ref) {
  const {
    children,
    onChange,
    disabled = false,
    checked: checkedProp,
    value,
    className,
    preventDefault = false,
    parentClassName,
  } = props;

  const ownerProps = {
    disabled,
    value,
  };

  const [checked, setChecked] = useState(false);

  const onChangeFunc = useCallback(
    (e) => {
      !preventDefault && setChecked(e.target.checked);
      onChange && onChange(e);
    },
    [onChange]
  );
  useEffect(() => {
    setChecked(!!checkedProp);
  }, [checkedProp]);

  const radioCls = clsx({
    'c-radio c-radio--inline': true,
    'c-radio--disabled': disabled,
    [className]: !!className,
  });

  return (
    <label className={clsx('c-radio-root', parentClassName)}>
      <div className={radioCls}>
        <div className="c-radio-wrapper">
          <span className={clsx(checked && 'checked')}></span>
          <div>{children}</div>
          <Input
            {...ownerProps}
            type="radio"
            onChange={onChangeFunc}
            slotProps={{
              input: { checked },
            }}
          />
        </div>
      </div>
    </label>
  );
});

export { Radio };
